import { Concatenate } from 'utils/string/string';
import { IConfirmationDocPayload } from './async-actions';
import { IClientConfirmationContacts, IConfirmationDoc } from './types';
import { convertToFormat } from 'app/helpers/dateHelper';
import { missingField } from 'app/constants';

/** TODO: Add contacts prop */
export const deriveConfirmationPayload = (
  payload: IConfirmationDocPayload,
  contacts: IClientConfirmationContacts,
  { employeeId: userId, firstName, lastName },
) => ({
  ...payload.template,
  placementClientConfirmationContacts: contacts ?? [],
  placementId: payload.placementId,
  userId,
  userName: Concatenate([firstName, lastName], ' '),
});

export const formatConfirmationDocs = (docs: IConfirmationDoc[]): IConfirmationDoc[] =>
  docs.map(doc => ({
    ...doc,
    isDraft: doc.status === 'Draft',
    version: `Version ${doc.version || missingField}`,
    view: {
      draftGeneratedDate: convertToFormat(doc.createdOn, 'MM/DD/YYYY h:mm A', true),
      docCreatedDate: convertToFormat(doc.createdOn, 'MM/DD/YYYY h:mm A', true),
      updateDate: convertToFormat(doc.updatedOn, 'MM/DD/YYYY h:mm A', true),
      sentDate: convertToFormat(doc.sentDate, 'MM/DD/YYYY h:mm A', true),
      cardUpdateDateString: `${doc.updatedByName ?? missingField} (${convertToFormat(
        doc.updatedOn,
        'MM/DD/YYYY h:mm A',
        true,
      )})`,
    },
  }));
